/**
 * Computes the lowercase hex-encoded SHA-256 digest of a string using the
 * Web Crypto API.
 */
export async function sha256Hex(input: string): Promise<string> {
  const buffer = new TextEncoder().encode(input)
  const hash = await crypto.subtle.digest('SHA-256', buffer)
  return Array.prototype.map
    .call(new Uint8Array(hash), (x: number) => ('00' + x.toString(16)).slice(-2))
    .join('')
}
